// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__mWUHT","content":"SuccessModal_content__w7Pzw","resultMessage":"SuccessModal_resultMessage__Gu+9F","closeButton":"SuccessModal_closeButton__6-QFp"};